var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"flex flex-col",style:({
    '--header-height': _vm.headerHeight,
    '--header-scroll-height': _vm.headerHeight,
  })},[_c('LoadingOverlay',{staticClass:"z-101 h-full",attrs:{"active":!_vm.isLoaded,"position-type":"fixed","delay":_vm.isBootLoaded ? 100 : 0}}),(_vm.$windowSize.isMobile && !_vm.hideHeader)?_c('MobileNavigation',{staticClass:"fixed bottom-[calc(0.125rem+env(safe-area-inset-bottom))] left-1 z-10 w-[calc(100%-var(--spacing)*2)]"}):_vm._e(),_c('portal-target',{attrs:{"name":"dropdownsContent","multiple":""}}),(_vm.isBootLoaded)?_c('SidebarManager'):_vm._e(),(_vm.isBootLoaded)?_c('ModalManager'):_vm._e(),(!_vm.hideHeader)?_c('header',{staticClass:"z-31 w-full",class:{
      fixed: !_vm.$windowSize.isMobile && _vm.layoutSettings?.header === 'fixed',
      'h-13':
        !_vm.$windowSize.isMobile &&
        _vm.layoutSettings?.header !== 'sticky' &&
        _vm.hideTopBar,
      'h-21':
        !_vm.$windowSize.isMobile &&
        _vm.layoutSettings?.header !== 'sticky' &&
        !_vm.hideTopBar,
      // 'h-8': !$windowSize.isMobile && layoutSettings?.header === 'sticky',
    }},[(!_vm.hideTopBar)?_c('HeaderTop',{staticClass:"bg-white dark:bg-neutral-900"}):_vm._e(),(!_vm.$windowSize.isMobile && _vm.layoutSettings?.header !== 'sticky')?_c('HeaderBottom',{}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"grow",class:{
      'pt-[calc(var(--spacing)*21)]':
        !_vm.$route.name?.startsWith('Interactive') &&
        !_vm.$windowSize.isMobile &&
        _vm.layoutSettings?.header === 'fixed' &&
        !_vm.hideHeader &&
        !_vm.hideTopBar,

      'pt-[calc(var(--spacing)*14)]':
        !_vm.$route.name?.startsWith('Interactive') &&
        !_vm.$windowSize.isMobile &&
        _vm.layoutSettings?.header === 'fixed' &&
        !_vm.hideHeader &&
        _vm.hideTopBar,
      'pt-2':
        _vm.$windowSize.isMobile &&
        !_vm.$route.name?.startsWith('Interactive') &&
        (_vm.hideHeader || _vm.hideTopBar),
    }},[(_vm.isBootLoaded)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }